// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Paging__desktop___3zfpx{grid-gap:8px;gap:8px;margin:80px auto}.Paging__desktop___3zfpx,.Paging__navButtons___a5s6j{display:flex;justify-content:center}.Paging__navButtons___a5s6j{color:inherit;font-weight:400;font-size:16px;line-height:24px;align-items:center;width:32px;height:32px;border:0;border-radius:8px;text-decoration:none;background:none;cursor:pointer}.Paging__navButtons___a5s6j:hover{background-color:#efeee9}.Paging__navButtons___a5s6j.Paging__activePage___3u2Qh{color:#fff;background-color:#2d50e6}.Paging__dots___3knWg{display:flex;align-items:center;justify-content:center;width:32px;height:32px}.Paging__disableLink___3_Nps{pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"desktop": "Paging__desktop___3zfpx",
	"navButtons": "Paging__navButtons___a5s6j",
	"activePage": "Paging__activePage___3u2Qh",
	"dots": "Paging__dots___3knWg",
	"disableLink": "Paging__disableLink___3_Nps"
};
module.exports = ___CSS_LOADER_EXPORT___;
